/**
 * Feature flags for the application.
 * These control which features are enabled/disabled.
 * 
 * AGENTIC FLAGS: Loaded from database for runtime control.
 * STATIC FLAGS: Defined here for compile-time control.
 */

// Static feature flags (compile-time, requires deploy to change)
export const staticFeatureFlags = {
  /**
   * Enable SMS nudge delivery channel.
   * When false:
   * - SMS UI is hidden in settings
   * - No phone numbers are collected
   * - No Twilio functions are invoked
   * - SMS channel is skipped in delivery
   */
  ENABLE_SMS_NUDGES: false,
  /**
   * Enable legacy nudge delivery (email, desktop push, SMS).
   * When false:
   * - Nudge delivery settings are hidden
   * - Browser push enrollment is disabled
   * - Legacy nudge cron functions short-circuit
   */
  ENABLE_LEGACY_NUDGES: false,
  /**
   * Enable the evidence-first living constellation map.
   * When false:
   * - Insights page uses legacy phase-based constellation
   * - New observational node states remain inactive
   */
  ENABLE_LIVING_CONSTELLATION: true,
  /** Keep authenticated proactive memory resolution and callers fail-closed. */
  ENABLE_PROACTIVE_MEMORY: true,
} as const;

// Agentic feature flag names (loaded from database)
export const AGENTIC_FLAGS = {
  ENABLE_LEADER_INTENT: 'ENABLE_LEADER_INTENT',
  ENABLE_LEADER_DRIFT_DETECTION: 'ENABLE_LEADER_DRIFT_DETECTION',
  ENABLE_COACH_SIGNALS: 'ENABLE_COACH_SIGNALS',
  ENABLE_COACH_SEQUENCING_ADVICE: 'ENABLE_COACH_SEQUENCING_ADVICE',
  ENABLE_COACH_MODE: 'ENABLE_COACH_MODE',
  ENABLE_COACHING_HEALTH_FACTUAL_CONTEXT_V2: 'ENABLE_COACHING_HEALTH_FACTUAL_CONTEXT_V2',
} as const;

export type AgenticFlagName = typeof AGENTIC_FLAGS[keyof typeof AGENTIC_FLAGS];
export type StaticFeatureFlags = typeof staticFeatureFlags;

// Combined for backwards compatibility
export const featureFlags = staticFeatureFlags;
export type FeatureFlags = StaticFeatureFlags;
